import { useMemo, useState, useEffect } from "react";
import { AppId, FCX, usePlatformContext } from "@datassential/platform-ui-lib";
import Ribbon, { RibbonItem } from "@components/Ribbon/Ribbon";
import { sanitizeUrl } from "@helpers";
import { components } from "@apiSchema";
import {
    BACKGROUND_TRANSITION_DELAY,
    RIBBON_DEFAULTS
} from "@pages/Home/sections/HomeReportsAndNews/HomeReportsAndNews.helpers";

const HomeReports: FCX<{
    data: components["schemas"]["ReportProPublicationClient"][];
    setBgSrc: (src: string) => void;
}> = ({
    data: rawData,
    setBgSrc,
}) => {
    const {
        userInfo: {
            reportProDetailsUrl,
            products,
        },
    } = usePlatformContext();
    const [activeItemIndex, setActiveItemIndex] = useState<number | null>(null);
    const [backgroundIndex, setBackgroundIndex] = useState<number | null>(null);

    useEffect(() => {
        const timer = setTimeout(() => {
            setBackgroundIndex(activeItemIndex);
        }, BACKGROUND_TRANSITION_DELAY);

        return () => clearTimeout(timer);
    }, [activeItemIndex]);

    const currentItem = useMemo(
        () => backgroundIndex !== null ? rawData?.[backgroundIndex] ?? null : null,
        [backgroundIndex, rawData]
    );

    useEffect(() => {
        setBgSrc(currentItem?.imageUrl ?? '');
    }, [currentItem, setBgSrc]);

    const reportProProduct = useMemo(
        () => products[AppId.ReportPro],
        [products]
    );

    const data = useMemo(
        (): RibbonItem[] => rawData?.map(i => ({
            id: i.id ?? 0,
            title: i.title ?? '',
            description: i.description ?? '',
            url: sanitizeUrl(`${reportProProduct.url}/${reportProDetailsUrl}/${i.id ?? ''}`),
            imageUrl: i.imageUrl ?? '',
        })) ?? [],
        [rawData, reportProDetailsUrl, reportProProduct]
    )

    return (
        <Ribbon
            {...RIBBON_DEFAULTS}
            items={data}
            setActiveTileIndex={setActiveItemIndex}
            className="appears-left"
        />
    );
}

export default HomeReports;